<template>
    <div id="login-change" class="basket-user">
        <div class="dropdown" v-if="isLoggedIn">
            <a href="#" class="dropdown-toggle basket-user__icon btn" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <svg class="icon icon-user d-sm-none" fill="currentColor">
                    <use xlink:href="#user" />
                </svg>
                <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>
            </a>
            <div class="account-menu dropdown-menu dropdown-menu-right small">
                <h6 class="dropdown-header">Konto</h6>
                <a class="dropdown-item" :href="$ceres.urls.myAccount">
                {{ $translate("Ceres::Template.loginMyAccount") }}</a>
                <a class="dropdown-item" href="#" v-logout> {{ $translate("Ceres::Template.loginLogout") }}</a>
            </div>
        </div>
        <div v-if="!isLoggedIn" class="dropdown">
            <a href="#" class="dropdown-toggle basket-user__icon btn" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
<!--                {{ $translate("Ceres::Template.loginMyAccount") }}-->
                <svg class="icon icon-user" fill="currentColor">
                    <use xlink:href="#user" />
                </svg>
            </a>
            <div class="account-menu dropdown-menu dropdown-menu-right small">
                <p class="dropdown-header">Konto</p>
                <a class="dropdown-item" data-testing="login-select"   :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal();unmarkInputFields()">
                    <span class="hidden-xs-down">{{ $translate("Ceres::Template.login") }}</span>
                </a>
<!--                <a class="dropdown-item" :href="isRegister ? 'javascript:void(0)' : '#registration'" :data-toggle="isRegister ? false : 'modal'" @click="createRegisterModal();unmarkInputFields()" v-if="showRegistration">-->
<!--                    <span class="hidden-xs-down">{{ $translate("Ceres::Template.loginRegister") }}</span>-->
<!--                </a>-->
                <a class="dropdown-item" href="/register">
                  <span class="hidden-xs-down">{{ $translate("Ceres::Template.loginRegister") }}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "ceres/app/services/ApiService";
import ValidationService from "ceres/app/services/ValidationService";
import { isDefined } from "ceres/app/helper/utils";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");

        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
